/* src/app/admin-dashboard/product/list-product/list-item/list-item.component.css */
a {
  margin: 5px;
  color: black;
}
.active {
  background: var(--custom-color);
}
.delete-icon {
  top: 0px;
  right: 0px;
  position: absolute;
  cursor: pointer;
  color: rgb(240, 240, 240);
}
/*# sourceMappingURL=list-item.component.css.map */
